module.exports = __webpack_public_path__ + "img/sintesis.76ce97cc.svg";